import React, {useContext, useEffect, useState} from 'react';
import { GlobalAppContext } from "src/components/App";
import { Task, TasksSearchRequest } from "src/models/dashboard/Task";
import { getAllTasksSearchPayload } from "./helpers/TasksSearchHelper";
import OpenTasksGrid from "./OpenTasksGrid";
import { Button, Checkbox, Header, SpaceBetween } from "@amzn/awsui-components-react";
import { PropertyFilterQuery } from '@amzn/awsui-collection-hooks';
import { convertPropertyFilterQueryToDbMainExpression } from './helpers/PropertyFilterHelper';
import MarkNotificationsComplete from '../shared/MarkNotificationsComplete';


export default function AllTasksView() {
    const { services, userProfile } = useContext(GlobalAppContext);

    const [allTasksSearchPayload, setAllTasksSearchPayload] = useState<TasksSearchRequest | undefined>(undefined);
    const [selectedNotifications, setSelectedNotifications] = useState([] as unknown as Task[]);
    const [isAllUsersViewChecked, setIsAllUsersViewChecked] = useState(false);
    const [ triggerMarkComplete, setTriggerMarkComplete ] = useState('');
    const [filteredCount, setFilteredCount] = useState<number | undefined>(undefined);

    const [allTasksResult, isSearchingTasks, searchTasksError] = services.dashboardService.searchTasks(allTasksSearchPayload);

    const getHeaderDescription = () => {
        if (isAllUsersViewChecked) {
            return "Assigned and relevant to all users";
        }
        return userProfile?.user ? `Assigned and relevant to me (@${userProfile.user})` : "Assigned and relevant to me";
    };


    const setUserViewMode = (payload?: TasksSearchRequest) => {
            if (payload == null){
                return;
            }
            if (isAllUsersViewChecked){
                setAllTasksSearchPayload({
                    ...payload,
                    userViewMode: "ALL"
                })
            }
            else {
                setAllTasksSearchPayload({
                    ...payload,
                    userViewMode: "SINGLE"
                })
            }
        }

    const filterChangedHandler = (searchQuery:PropertyFilterQuery) => {
        if (allTasksSearchPayload == null){
            return;
        }
        if (searchQuery.tokens.length === 0){
            setAllTasksSearchPayload(getAllTasksSearchPayload());
            return;
        }
        setAllTasksSearchPayload({...allTasksSearchPayload, filterExpression: convertPropertyFilterQueryToDbMainExpression(searchQuery)})
    }

    const postProcessAfterMarkComplete = () => {
        if (allTasksSearchPayload == null) {
            return;
        }

        setSelectedNotifications([]);
        setAllTasksSearchPayload({...allTasksSearchPayload});
    }

    useEffect(() => {
        setAllTasksSearchPayload(getAllTasksSearchPayload());
        // Scroll to top when component mounts
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        if (allTasksSearchPayload == null){
            return;
        }
        setUserViewMode(allTasksSearchPayload);
    }, [isAllUsersViewChecked]);


    return <div>
                <div className="allUsersViewContainer">
                    <Checkbox
                        onChange={({ detail }) =>
                            setIsAllUsersViewChecked(detail.checked)
                        }
                        checked={isAllUsersViewChecked}
                        >
                        All users view
                    </Checkbox>
                </div>
                <OpenTasksGrid 
                    openTasksResult={allTasksResult} 
                    isLoading={isSearchingTasks} 
                    dashboardView={true}
                    showFilter={true}
                    enableClientSidePagination={true}
                    isAllTasksView={true}
                    gridHeader={<>
                        <br/>
                        <Header counter={`(${filteredCount !== undefined ? filteredCount : allTasksResult?.items.length || '...'})`} 
                                description={getHeaderDescription()}
                                actions={<Button disabled={selectedNotifications.length == 0} onClick={() => setTriggerMarkComplete(new Date().toString())}>
                                            Mark as completed
                                        </Button>}
                        >
                                All tasks
                        </Header>
                    </>} 
                    onFilterQueryChanged={filterChangedHandler}
                    onFilteredCountChange={setFilteredCount}
                    selectedNotifications={selectedNotifications}
                    setSelectedNotifications={(selectedItems: Task[]) => setSelectedNotifications(selectedItems)}
                />
                <MarkNotificationsComplete triggerAction={triggerMarkComplete} selectedNotifications={selectedNotifications} postProcess={postProcessAfterMarkComplete}/>
            </div>
}